module.exports = __webpack_public_path__ + "img/competition.cd08d66d.svg";